export default __webpack_public_path__ + "static/media/img.3426bed1.jpg";